module.exports = __webpack_public_path__ + "img/20200317105222880.502f530f.png";